// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3611":"1e41102f","6164":"1e41102f"}[chunkId] + ".chunk.css";
};